
<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
	<div class="d-flex align-items-center">

      <el-form inline ref="form" :model="searchform">
          <el-form-item class="mb-0 mr-0">
             {{$t('status.알본선택')}}:<el-select v-model="admin_id"  style="width: 100px;" class="ml-2 mr-2" size="mini" >
               <el-option
                      v-for="item in adminlist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
             <el-select v-model="searchform.value3" :placeholder="$t('searchText.구분')" size="mini"  style="width:120px" >
               <el-option
                      v-for="item in searchform.searchOptions3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
              <el-select v-model="provider_name"  style="width: 150px;" class="ml-2 mr-2" size="mini" filterable >
               <el-option
                      v-for="item in providerlist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>
        <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value2" :placeholder="$t('searchText.상태선택')" size="mini" style="width:90px" >
               <el-option
                      v-for="item in searchform.searchOptions2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>

          <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value"  :placeholder="$t('searchText.타이틀선택')"  size="mini" style="width:100px" >
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>


          <el-form-item class="mb-0 mr-0">
             <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:120px" ></el-input>
          </el-form-item>
          <el-form-item  class="mb-0 mr-0">
             <el-date-picker
                  v-model="searchform.time"
                  type="datetimerange"
                  range-separator="~"
                  :start-placeholder="$t('searchText.시작')"
                  :end-placeholder="$t('searchText.마감')" class="mr-2" value-format="yyyy-MM-dd HH:mm:ss" 
                  :default-time="['00:00:00','23:59:59']" style="width:300px">
                </el-date-picker>
          </el-form-item>
          <el-form-item class="mb-0 mr-0">
            <el-button type="info" size="mini" @click="searchEvent" :loading="sLoading">{{$t('searchText.검색')}}</el-button>  
          </el-form-item>
      </el-form>
       
     <span class="ml-1">배팅내역은2일만저장</span>
    
      
        
    </div>
	<div class="d-flex align-items-center mt-2">
		
		<el-input :placeholder="$t('searchText.구글OTP')" v-model="otp" size="mini" style="width: 100px;" class="mr-2"></el-input>
      <el-button type="danger"size="mini" @click="deleteAll">{{$t('searchText.선택삭제')}}</el-button>
       <el-button type="success" size="mini" icon="el-icon-document-delete" @click="exportExcel" :disabled = "disabled">{{$t('searchText.엑셀다운')}}</el-button> 
   <div class="text-muted ml-2 mr-2"><span class="text-info ml-2 mr-2">{{$t('nav.배팅')}}:{{formatMoney(total_money)}}</span>({{$t('msg.카')}}:{{formatMoney(total_money_e)}} {{$t('msg.슬')}}:{{formatMoney(total_money_slot)}})|<span class="text-success ml-2 mr-2">{{$t('msg.적중')}}:{{formatMoney(total_emoney)}}</span>({{$t('msg.카')}}:{{formatMoney(total_emoney_e)}} {{$t('msg.슬')}}:{{formatMoney(total_emoney_slot)}})|<span class="text-danger ml-2">{{$t('searchText.차액')}}:{{formatMoney(minus)}}</span><span class="text-secondary ml-4">슬공배팅:{{formatMoney(slot_gongbet)}}</span><span class="text-secondary ml-2">카공배팅:{{formatMoney(ca_gongbet)}}</span><span class="text-secondary ml-2">카타이:{{formatMoney(ca_tie)}}</span></div>
    <el-button type="primary"size="mini" @click="jackpot">{{$t('searchText.천만이상적중')}}</el-button>


		
	
	</div>
  
  <div v-if="(this.userid=='bon' || this.userid=='admin' || this.userid=='soft07') && this.api_type=='sg' && this.sitetype=='4'" class="d-flex mt-2">
     
     <el-date-picker
                  v-model="date"
                  type="date"
                  size="mini" class="mr-2"  style="width:200px;" :placeholder="$t('searchText.날자선택')" value-format="yyyy-MM-dd">
      </el-date-picker>
       <el-select v-model="betValue" :placeholder="$t('searchText.타이틀선택')" size="mini" style="width:120px;" class="mr-2">
               <el-option
                      v-for="item in betOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
        </el-select>
         <el-input :placeholder="$t('searchText.키워드')" v-model="betKeyword" size="mini" class="mr-2"  style="width:100px;"></el-input>
         <el-input :placeholder="$t('searchText.페이지')" v-model="page" size="mini"  class="mr-2" style="width:100px;"></el-input>
        <el-button type="primary" :loading="betLoading" size="mini" @click="loadClick">{{$t('searchText.불러오기')}}</el-button>
  </div>

  <div v-if="(this.api_type=='sd' || this.userid=='admin') && this.sitetype=='4' " class="d-flex mt-2">
     <el-date-picker
                  v-model="date"
                  type="date"
                  size="mini" class="mr-2"  style="width:200px;" :placeholder="$t('searchText.날자선택')" value-format="yyyy-MM-dd">
      </el-date-picker>
       <el-select v-model="betValue" :placeholder="$t('searchText.타이틀선택')" size="mini" style="width:120px;" class="mr-2">
               <el-option
                      v-for="item in betOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
        </el-select>
         <el-input :placeholder="$t('searchText.키워드')" v-model="betKeyword" size="mini" class="mr-2"  style="width:100px;"></el-input>
         <el-select v-model="page" :placeholder="$t('searchText.시간선택')" size="mini" style="width:120px;" class="mr-2" filterable>
               <el-option
                      v-for="item in betOptions2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
        </el-select>
        <el-button type="primary" :loading="betLoading" size="mini" @click="loadClick_sd">{{$t('searchText.불러오기')}}</el-button>
  </div>

   <div v-if="this.userid=='admin' && this.sitetype=='4' " class="d-flex mt-2">
     <el-date-picker
                  v-model="date2"
                  type="date"
                  size="mini" class="mr-2"  style="width:200px;" :placeholder="$t('searchText.날자선택')" value-format="yyyy-MM-dd">
      </el-date-picker>
       <el-select v-model="betValue2" :placeholder="$t('searchText.시간선택')" size="mini" style="width:120px;" class="mr-2" filterable>
               <el-option
                      v-for="item in betOptions2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
        </el-select>
         이벤트지금않함 <el-checkbox true-label="1" false-label="0" v-model="noe" class="mr-2"></el-checkbox>
        <el-button type="primary" :loading="betLoading2" size="mini" @click="loadClick2">{{$t('searchText.롤링처리')}}</el-button>
  </div>

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
       :empty-text="$t('tableText.데이타가없습니다')" @selection-change="handleSelectionChange"  @sort-change='tableSortChange'>
     <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column> 
    <el-table-column width="70" align="center" label="ID">

          <template v-if="loading==false" slot-scope="scope">{{total-(currentPage-1)*50-scope.$index}}</template>
        </el-table-column>
     
       <el-table-column
        
       :label="$t('nav.아이디')" prop="username" align="center" >
          <template slot-scope="scope">
            
             <span class="text-primary" style="cursor:pointer" @click="openModel(scope.row.username)">{{scope.row.username}} ({{scope.row.mem_name}})</span>
          </template>
      </el-table-column>

 
        <!--  <el-table-column
        :label="$t('tableText.부본사총판매장')"  prop="b_code" align="center" width="150">
        <template slot-scope="scope">
          {{scope.row.b_code}}-{{scope.row.a_code}}-{{scope.row.c_code}}
        </template>
      </el-table-column>-->

       <el-table-column
        :label="$t('nav.게임사')" prop="provider_name" align="center" >
        <template slot-scope="scope">
          {{scope.row.provider_name}}
        </template>
      </el-table-column>

      <el-table-column
        :label="$t('tableText.게임')" prop="game_title" align="center" >
        <template slot-scope="scope">
          {{scope.row.game_title}}
        </template>
      </el-table-column>

      

       <el-table-column
        
        :label="$t('msg.회차')"  prop="round_id"  align="center">
        <template slot-scope="scope">
         <el-input
                          type="textarea"
                          :rows="1"
                          v-model="scope.row.round_id">
                        </el-input>
        </template>
      </el-table-column>


    
      


       <el-table-column
        
        :label="$t('nav.배팅금액')" prop="bet" align="center" sortable="custom">
        <template slot-scope="scope"><span :class="String(scope.row.total_loging) === '3' && (scope.row.type === 'Slots' || scope.row.game_type === 'Slots') ? 'text-danger' : ''">{{ formatMoney(scope.row.bet)}}</span></template>

      </el-table-column>

       


       <el-table-column
        
         :label="$t('nav.당첨금액')" prop="win" align="center" sortable="custom">
        <template slot-scope="scope">{{ formatMoney(scope.row.win)}}</template>

      </el-table-column>


     
      <el-table-column
        
        :label="$t('tableText.상태')" prop="tx_type" align="center" >
         <template slot-scope="scope">
           {{scope.row.tx_type}}
        </template>
      </el-table-column>

        <el-table-column
        
        label="API" prop="opcode" align="center" >
         <template slot-scope="scope">
           {{scope.row.opcode}}
        </template>
      </el-table-column>


 <el-table-column
                  prop="txid" align="center"
                  :label="$t('msg.상세')">
                   <template slot-scope="scope">
        
                          <el-button type="default" size="mini" @click="linkBtn(scope)" :loading="false">{{$t('msg.상세보기')}}</el-button>
 
                  </template>
                </el-table-column> 
      
       <el-table-column
        
        :label="$t('searchText.구매시간')" prop="create_at" align="center" sortable="custom">
        <template slot-scope="scope">{{ scope.row.create_at}}</template>
      </el-table-column>
       
       <el-table-column
        
        :label="$t('searchText.카지노잔액')" prop="balance" align="center">
        <template slot-scope="scope">{{ formatMoney(scope.row.balance)}}</template>
      </el-table-column>
       
       
      
      
		
		  
	
		 
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
       
</div>
 </template>

 <script>
  import * as XLSX from 'xlsx/xlsx.mjs';
 import layer from '../../components/common/layer.vue';
 import jackpot from '../../components/common/jackpot.vue';
 import layerNew from '../../components/common/layer-new.vue';
import transaction from '../../components/common/transaction.vue';
import bettingDetails from '../../components/common/betting-details.vue';
import holdem from '../../components/common/holdem.vue';
    export default {
     components: {
      layer,transaction,holdem,bettingDetails,jackpot
    },
    	data(){
    		return{
         order:'',
          prop:'',
          api_type:'sg',
          sLoading:false,
          viewbtn:false,
           otp:'',
          disabled:false,
          betLoading2:false,
          betLoading:false,
          domain:window.sessionStorage.getItem('domain'),
          sitetype:window.sessionStorage.getItem('sitetype'),
           bg:window.sessionStorage.getItem('bg'),
           userid:window.sessionStorage.getItem('userid'),
           aid:window.sessionStorage.getItem('admin_id'),
          formLoading:false,
          idDialogVisible: false,
    		  buy_good0:'',
          buy_good0_sum:'',
          admin_id:'',
          total_emoney:'',
          total_money:'',
        
          adminlist:[{
                label:this.$i18n.t("status.선택"),
                value:''
            },
            
            ],
          providerlist:[
            {
                label:this.$i18n.t("status.선택"),
                value:''
            },
            ],
          provider_name:'',
               total_money_e:'',
          total_money_slot:'',
          slot_gongbet:'',
          ca_gongbet:'',
          ca_tie:'',
           total_emoney_e:'',
          total_emoney_slot:'',
          game_codes:{
              'PWB_NB_MIX':this.$i18n.t("msg.일반조합"),
              'PWB_PB_MIX':this.$i18n.t("msg.파워조합"),
              
              'PWB_NBPB_MIX':'',
              'PWB':'',
              'PWB_NBPB_MIX3':'',             
            },
              options: [{
                label: this.$i18n.t("msg.대기"),
                value: '1',
               
              }, {
                label: this.$i18n.t("msg.처리중"),
                 value: '2',
                
              }, {
                label: this.$i18n.t("msg.완료"),
                 value: '3',
               
              }, {
                label: this.$i18n.t("msg.취소"),
                 value: '4',
               
              }], 
    		
	           
    			searchform:{
    				keyword:'',
    				time:[],
    				searchOptions:[
                
    				
		         {
              label:this.$i18n.t("msg.아이디"),
              value:'mem_id'
            }
            ,
            {
              label:this.$i18n.t("msg.매장"),
              value:'c_code'
            },
            {
              label:this.$i18n.t("msg.총판"),
              value:'a_code'
            },
            {
              label:this.$i18n.t("msg.부본사"),
              value:'b_code'
            },
            {
              label:this.$i18n.t("msg.본사"),
              value:'s_code'
            },
            {
              label:this.$i18n.t("msg.마스터"),
              value:'m_code'
            },
            
            {
              label:this.$i18n.t("newAdd.게임"),
              value:'game_title'
            }
            
		       

		        ],
		       searchOptions2:[
                
            {
              label:this.$i18n.t("msg.전체"),
              value:''
            },{
              label:this.$i18n.t("msg.적중"),
              value:'win'
            },
            {
              label:this.$i18n.t("msg.배팅"),
              value:'bet'
            },
            {
              label:this.$i18n.t("msg.환불"),
              value:'refund'
            },
            {
              label:this.$i18n.t("msg.취소"),
              value:'cancel'
            },
            ],
            searchOptions3:[
            {
             label:this.$i18n.t("msg.전체"),
              value:''
            },
            {
              label:this.$i18n.t("msg.슬롯"),
              value:'Slots'
            },
            {
             label:this.$i18n.t("msg.라이브"),
              value:'Live Casino'
            },
            
            ],
		        value:'',
		        value2:'',
            value3:'',


    			},
    			 pickerOptions: {
    			},
          shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        
    
       
    			
		        
    		
		    		 total:0,
		    		 size:0,
		    		 loading: false,
		    		 editIndex:-1,
		    		 creatModel:false,
		    		 tableData: [],
			         currentPage:1,
			         multipleSelection:[],
               date:'',
               date2:'',
               betOptions:[

                {
                  label:this.$i18n.t("nav.아이디"),
                  value:'mem_id'
                }
                ],
               betValue:'',
               betKeyword:'',
               page:'',
                betOptions2:[

                {
                  label:this.$i18n.t("msg.시0"),
                  value:'00'
                },
                {
                  label:this.$i18n.t("msg.시1"),
                  value:'01'
                },
                {
                  label:this.$i18n.t("msg.시2"),
                  value:'02'
                },
                {
                  label:this.$i18n.t("msg.시3"),
                  value:'03'
                },
                {
                  label:this.$i18n.t("msg.시4"),
                  value:'04'
                },
                {
                  label:this.$i18n.t("msg.시5"),
                  value:'05'
                },
                {
                  label:this.$i18n.t("msg.시6"),
                  value:'06'
                },
                {
                  label:this.$i18n.t("msg.시7"),
                  value:'07'
                },
                {
                  label:this.$i18n.t("msg.시8"),
                  value:'08'
                },
                {
                  label:this.$i18n.t("msg.시9"),
                  value:'09'
                },
                {
                  label:this.$i18n.t("msg.시10"),
                  value:'10'
                },
                {
                  label:this.$i18n.t("msg.시11"),
                  value:'11'
                },
                {
                  label:this.$i18n.t("msg.시12"),
                  value:'12'
                },
                {
                  label:this.$i18n.t("msg.시13"),
                  value:'13'
                },
                {
                  label:this.$i18n.t("msg.시14"),
                  value:'14'
                },
                {
                  label:this.$i18n.t("msg.시15"),
                  value:'15'
                },
                {
                  label:this.$i18n.t("msg.시16"),
                  value:'16'
                },
                {
                  label:this.$i18n.t("msg.시17"),
                  value:'17'
                },
                {
                  label:this.$i18n.t("msg.시18"),
                  value:'18'
                },
                {
                  label:this.$i18n.t("msg.시19"),
                  value:'19'
                },
                {
                  label:this.$i18n.t("msg.시20"),
                  value:'20'
                },
                 {
                  label:this.$i18n.t("msg.시21"),
                  value:'21'
                },
                 {
                  label:this.$i18n.t("msg.시22"),
                  value:'22'
                },
                 {
                  label:this.$i18n.t("msg.시23"),
                  value:'23'
                },
                ],
               betValue2:'',
               noe:'',
			        
			         
			 
    			}
    			
    			
    		},
    		created() {
          this.getProvide();
    			let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'get',
                  url:this.domain+'/admin/bubonlist_select?type=bossnull&admin=1',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
           let newids=[];

            let obj={};
            obj.label=this.$i18n.t("msg.없음")
            obj.value=''
            newids.push(obj); 

            newids=[];

            


            response.data.admin.forEach(item=>{
            let obj={};
            obj.label=item.name
            obj.value=item.name
            newids.push(obj);            
           });


           

           this.adminlist=newids
    
            }).catch((error) =>{
              
            })


    			this.getList();
    			
			
		},
    computed:{
      minus(){
        return this.total_money - this.total_emoney
      }

    },
    	
    	methods:{
          // 关闭弹框（头部的X）
        handleClose () {
               this.idDialogVisible = false
            },
        cancelData(){
          this.idDialogVisible = false
        },
        tableSortChange(column) {
 
         this.prop= column.prop
         this.order= column.order
         
        this.getList()
     },
  exportExcel() {

    if(this.total>1000)
    {
        this.$message(this.$i18n.t("msg.내역이1000건이넘습니다1000건아래로검색하신후다운로드해주세요"),);
        return;
    }
    this.$confirm(this.$i18n.t("msg.오늘배팅내역만다운가능합니다"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.확인"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
           let token=window.sessionStorage.getItem('user');
         this.disabled = true

         let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

                let urls=this.domain+'/admin/apibetlist?excel=1&admin_id='+this.admin_id+'&game_code='+this.searchform.value3+'&buy_good='+this.searchform.value2+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage;

          
         

          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{

               if(response.data.code!=200)
               {
                   this.$message.error(response.data.msg);
                   return;
               }


               let data = response.data.data

                this.total = response.data.total


               let wopts = {
                  bookType: 'xlsx',
                  bookSST: true,
                  type: 'binary'
                };
                let workBook = {
                  SheetNames: ['Sheet1'],
                  Sheets: {},
                  Props: {}
                };

                let table =data
                this.disabled = false

      
 
      workBook.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(table);

      XLSX.utils.sheet_add_aoa(workBook.Sheets['Sheet1'], [["Created "+new Date().toISOString()]], {origin:-1});
      XLSX.writeFile(workBook, "bet.xlsb");

       this.$message.success(this.$i18n.t("msg.엑셀저장완료"))

                     
                     // this.tableData =data.data
                    
               
            }).catch((error) =>{
              
               this.$message.error(error);
              this.loading = false
               
            })

        })
        
      
     

 
  
    },
    getProvide(){
        let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'get',
                  url:this.domain+'/admin/get_provider',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              console.log('providelist',response.data)
           let newids=[];
            response.data.data.forEach(item=>{
            let obj={};
            obj.label=item.provider_name
            obj.value=item.provider_name
            newids.push(obj);            
           });


           

           this.providerlist=newids
    
            }).catch((error) =>{
              
            })

    },
     linkBtn(e){
 
      if(this.viewbtn)
      {
         console.log('false');
         return;
      }

      this.viewbtn=true
   
       let token=window.sessionStorage.getItem('user');
      

           this.$axios({
                  method:'get',
                  url:this.domain+'/admin/getGameCategory?opcode='+e.row.opcode+'&provider_name='+e.row.provider_name+'&admin_id='+e.row.admin_id+'&dd='+e.row.create_at+'&user_id='+e.row.user_id+'&username='+e.row.username+'&ping='+e.row.ping+'&round_id='+e.row.round_id+'&txid='+e.row.txid,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
 
            }).then((response) =>{ 



             if ( response.data.code == "500")
             {
                 alert(response.data.msg);
             }
             else if(response.data.code=="100"){
             

               //console.log('settledAt',response.data.data.data.data.settledAt)

              let bets=response.data.data.data.data.participants[0].bets;
              let newbet1=[];
              let newbet2=[];
              let newbet3=[];
              let newbet4=[];

              let modifiedArr = bets.map(function(element){
                 if(element["code"].indexOf("Banker")>0)
                 { 
                      newbet1.push(element);
                 }
                 if(element["code"].indexOf("Player")>0)
                 { 
                      newbet2.push(element);
                 }
                 if(element["code"].indexOf("Tie")>0)
                 { 
                      newbet3.push(element);
                 }
                 if(element["code"].indexOf("Etc")>0)
                 { 
                      newbet4.push(element);
                 }
                 
                 
              });
              console.log('newbet1',newbet1)

                 
                  this.$layer.iframe({
                    type: 2,
                    title: e.row.username+' '+e.row.create_at,
                    content: {
                        content: transaction,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        BAC_Banker:newbet1,
                        BAC_Player:newbet2,
                        BAC_Tie:newbet3,
                        BAC_Etc:newbet4,
                        outcome:response.data.data.data.data.result.outcome,
                        banker_cards:response.data.data.data.data.result.banker.cards,
                        player_cards:response.data.data.data.data.result.player.cards,
                        banker:{score:response.data.data.data.data.result.banker.score},
                        player:{score:response.data.data.data.data.result.player.score},
                        dealer:{name:response.data.data.data.data.dealer.name},
                        table:{name:response.data.data.data.data.table.name},
                        gameProvider:response.data.data.data.data.gameProvider,
                        totalStake:response.data.data.data.data.totalStake,
                        totalPayout:response.data.data.data.data.totalPayout,
                        gameType:response.data.data.data.data.gameType,
                        status:response.data.data.data.data.status,
                        settledAt:response.data.data.data.data.settledAt,
                        skin: 'layer_bg',
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['830px', '850px'],
                 
                });

             } else if(response.data.code=="300"){
              console.log(response.data.mem_id)
               this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: bettingDetails,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.data.status,
                        settledAt:response.data.data.data.settledAt,
                        startedAt:response.data.data.data.startedAt,
                        table:{name:response.data.data.data.table.name},
                        dealer:{name:response.data.data.data.dealer.name},
                        gameProvider:response.data.data.data.gameProvider,
                        banker_cards:response.data.data.data.result.banker.cards,
                        player_cards:response.data.data.data.result.player.cards,
                        outcome:response.data.data.data.result.outcome,
                        banker:{score:response.data.data.data.result.banker.score},
                        player:{score:response.data.data.data.result.player.score},
                        bets:response.data.data.data.participants[0].bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                });

             }else if(response.data.code=="302"){
               this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: bettingDetails,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.status,
                        settledAt:response.data.data.startedAt,
                        startedAt:response.data.data.startedAt,
                        table:{name:''},
                        dealer:{name:response.data.data.dealer.name},
                        gameProvider:response.data.data.vendor,
                        banker_cards:response.data.data.result.banker.cards,
                        player_cards:response.data.data.result.player.cards,
                        outcome:response.data.data.result.outcome,
                        banker:{score:response.data.data.result.banker.score},
                        player:{score:response.data.data.result.player.score},
                        bets:response.data.data.participants[0].bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                });

             }else if(response.data.code=="303"){
            
               this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: holdem,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.status,
                        settledAt:response.data.data.startedAt,
                        startedAt:response.data.data.startedAt,
                        table:{name:''},
                        dealer:{name:response.data.data.dealer.name},
                        gameProvider:response.data.data.vendor,
                       
                        
                        
                        bets:response.data.data.details.bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                });

             } else if(response.data.code=="301"){


               if(typeof(response.data.data.detail.data.result.banker) == "undefined")
               {


                 var data = response && response.data && response.data.data || {}
                var detailData = data.detail && data.detail.data || {}
                var result = detailData.result || {}

                   this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: holdem,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.detail.data.status,
                        settledAt:response.data.data.detail.data.settledAt,
                        startedAt:response.data.data.detail.data.startedAt,
                        table:{name:response.data.data.detail.data.table.name},
                        dealer:{name:response.data.data.detail.data.dealer.name},
                        gameProvider:response.data.data.detail.data.gameProvider,
                        result: result,
                        bets:response.data.data.detail.data.participants[0].bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                  });
                    this.viewbtn=false
                   return;
               }

               this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: bettingDetails,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.detail.data.status,
                        settledAt:response.data.data.detail.data.settledAt,
                        startedAt:response.data.data.detail.data.startedAt,
                        table:{name:response.data.data.detail.data.table.name},
                        dealer:{name:response.data.data.detail.data.dealer.name},
                        gameProvider:response.data.data.detail.data.gameProvider,
                        banker_cards:response.data.data.detail.data.result.banker.cards,
                        player_cards:response.data.data.detail.data.result.player.cards,
                        outcome:response.data.data.detail.data.result.outcome,
                        banker:{score:response.data.data.detail.data.result.banker.score},
                        player:{score:response.data.data.detail.data.result.player.score},
                        bets:response.data.data.detail.data.participants[0].bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                });

             }else if(response.data.code=="400"){
              console.log(response.data.orders)
               this.$layer.iframe({
                    type: 2,
                    title: '베팅 상세 내역',
                    content: {
                        content: holdem,
                        parent: this,
                        data:{
                        info:{id:e.row.admin_id},
                        status:response.data.data.data.status,
                        settledAt:response.data.data.data.settledAt,
                        startedAt:response.data.data.data.startedAt,
                        table:{name:response.data.data.data.table.name},
                        dealer:{name:response.data.data.data.dealer.name},
                        gameProvider:response.data.data.data.gameProvider,
                       
                        
                        
                        bets:response.data.data.data.participants[0].bets,
                        agent:response.data.agent,
                        mem_id:response.data.mem_id,
                        orders:response.data.orders,
                       
                        }
                      
                    },
                    shadeClose: false,
                    maxmin:true,
                    shade: false,
                    area: ['1000px', '850px'],
                 
                });

             }
             else if(response.data.code=="200")
             {
                 window.open(response.data.data,'_blank')
             }else
             {
              
             }

             this.viewbtn=false
                 
                 
               
            }).catch((error) =>{
                this.viewbtn=false
            })

        },
    			 // 搜索事件
			searchEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                	this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                	 return;
                }

               this.sLoading = true
            this.currentPage=1;


    			this.getList();
    			
             

    		},
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			     handleSelectionChange(val) {
          //console.log(val)
                this.multipleSelection = val;

      },
       openModel(id){
 let pix=window.screen.width;
           
                let width='1080px';
                if(pix<1200)
                {
                  width='95%';
                }
        if(this.aid=='soft10')
           {
                this.$layer.iframe({
                type: 2,
                title: id,
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    layerid:'id'
                    }
                  
                },
                shadeClose: false,
                maxmin:true,
                shade: false,
                  area: [width+'', '700px'],
             
             });
              return;
           }
            this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['830px', '680px'],
         
        });
        },
        jackpot(){
          let pix=window.screen.width;
          let width='1080px';
                if(pix<1200)
                {
                  width='95%';
                }
      
                this.$layer.iframe({
                type: 2,
                title: '천만이상적중',
                content: {
                    content: jackpot,
                    parent: this,
                    data:{
                   
                    }
                  
                },
                shadeClose: false,
                maxmin:true,
                shade: false,
                  area: [width+'', '700px'],
             
             });
              
           
           
        },
       // 批量删除
      deleteAll(){
       this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
         confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');

          console.log('hh',this.multipleSelection);

                    let newids=[];

           this.multipleSelection.forEach(item=>{
            
            console.log('id',item.id);
            newids.push(item.id);
           });

           console.log('newids',newids);

          this.$axios({
                      method:'post',
                       data:{idx:newids,opt:this.otp},
                      url:this.domain+'/admin/apibet_del',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })

        
      },  
      loadClick(){
        this.betLoading = true
              
         let token=window.sessionStorage.getItem('user');
          this.$axios({
                      method:'post',
                       data:{
                        page:this.page,
                        key:this.betKeyword,
                         value:this.betValue,
                         date:this.date,
                         admin_id:this.admin_id



                       },
                      url:this.domain+'/admin/getslotgatebet',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.betLoading = false
                    //this.getList()
    
                  }).catch((error) =>{
                      console.log(error)  
                      this.betLoading = false    
                  })

      },
      loadClick_sd(){
        this.betLoading = true
              
         let token=window.sessionStorage.getItem('user');
          this.$axios({
                      method:'post',
                       data:{
                        page:this.page,
                        key:this.betKeyword,
                         value:this.betValue,
                         date:this.date,
                          admin_id:this.admin_id



                       },
                      url:this.domain+'/admin/getslotdiabet',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.betLoading = false
                    //this.getList()
    
                  }).catch((error) =>{
                      console.log(error)  
                      this.betLoading = false    
                  })

      },
       loadClick2(){
         this.betLoading2 = true              
         let token=window.sessionStorage.getItem('user');
          this.$axios({
                      method:'post',
                       data:{
                        
                         date:this.date2,
                         time:this.betValue2,
                         noe:this.noe
                       },
                      url:this.domain+'/admin/rogset_back',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.betLoading2 = false
                    //this.getList()
    
                  }).catch((error) =>{
                      console.log(error)  
                      this.betLoading2 = false    
                  })

      },
    		getList(){

    		

               let s_time="";
               let e_time="";

               if(this.searchform.time.length>0)
               {
                  s_time=this.searchform.time[0];
                  e_time=this.searchform.time[1];
               }

         
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/apibetlist?admin_id='+this.admin_id+'&game_code='+this.searchform.value3+'&buy_good='+this.searchform.value2+'&s_time='+s_time+'&e_time='+e_time+'&'+this.searchform.value+'='+this.searchform.keyword+'&page='+this.currentPage+'&provider_name='+this.provider_name+'&fit='+this.prop+'&order='+this.order;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 

                    if(response.data.code==200){
                      
                      
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                        return;
                    }
                  
                     let data = response.data.data
                     this.tableData =data.data
                     this.total = data.total
                     this.currentPage = data.current_page
                     this.size =data.per_page
                     this.buy_good0 = response.data.buy_good0
                     this.buy_good0_sum = response.data.buy_good0_sum
                     this.total_emoney = response.data.total_emoney
                     this.total_money = response.data.total_money

                      this.total_money_e = response.data.total_money_e
                      this.total_money_slot = response.data.total_money_slot
                      this.slot_gongbet = response.data.slot_gongbet || data.slot_gongbet || 0
                      this.ca_gongbet = response.data.ca_gongbet || data.ca_gongbet || 0
                      this.ca_tie = response.data.ca_tie || data.ca_tie || 0
                      this.total_emoney_e = response.data.total_emoney_e
                     this.total_emoney_slot = response.data.total_emoney_slot
                     this.loading =false
                     this.sLoading = false
                     this.api_type=response.data.api_type
               
            }).catch((error) =>{
            
               this.$message.error(error);
              this.loading = false
             
               
            })
    		},
    	 goodUp(e,v){
         this.$confirm(this.$i18n.t("msg.수정하시겠습니까"), this.$i18n.t("msg.알림"), {
                 confirmButtonText:this.$i18n.t("msg.수정"),
                cancelButtonText: this.$i18n.t("msg.취소"),
                type: 'warning'
              }).then(() => {

                 this.disabled = true
           let token=window.sessionStorage.getItem('user');
           this.$axios({
                  method:'post',
                  url:this.domain+'/admin/good_up',
                  data:{
                    id:e.row.id,
                    old:0,
                    good:v
                  },
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },

            }).then((response) =>{ 
              console.log(response)
              if(response.data.code==200)
                      {
                         this.$message({
                          message:response.data.msg,
                          type: 'success'
                        });

                           this.getList()

                          
                      }else{
                       this.$message.error(response.data.msg)

                      }
                      this.disabled = false


               
            }).catch((error) =>{
             
             console.log('error',error.response)       //请求失败返回的数据
               
            })
                                
       

                }).catch(() => {
                    this.$message({
                      type: 'info',
                      message:this.$i18n.t("msg.취소됨"),
                    });          
                  });

          
        },
    		
    	
    		
    	}
  }
</script>

 <style scoped>
 /deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 /deep/ .el-dialog{
    height:700px;overflow-y:scroll
 }
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }

</style>



// WEBPACK FOOTER //
// src/views/betting1/list.vue